import React, {useEffect, useState} from 'react'
import { useNavigate } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";
import { LoginAfterCheckLogin,ChangeDateStringOnlyDate } from "../../components/common/Common";

const ToggleStudySet = () => {
  LoginAfterCheckLogin(2);  //로그인 상태 점검
  const branch_idx = Number(localStorage.getItem('branch_idx'));
  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);
  const navigate = useNavigate();
  const [varChildrenList,setChildrenList] = useState([]);

  //원생 수업상세정보 호출
  const GetChildrensForStopping = async() => {
    const sendData = {branch_idx:branch_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_childrens_toggle`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        setChildrenList(datas.results); 
      } else {
        alert(datas.message);
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varBranchMenus);
    setBranchMenus({showMenu:true,gotoMain:1});
    GetChildrensForStopping();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onToggleClassStudyInfoHandler = (e,ch_idx,cl_idx) => {
    navigate(`/Branch/ToggleClassStudy/${ch_idx}/${cl_idx}`);
  }

  return (
    <div className="vh-content center-view-wrap">
      <HeaderBranchTitle varPageTitle={'수강 재개'} />
      <div className="vh-content-body">
        <div className="center-wrap">
          {varChildrenList.length===0?
            <div className="con-box">
              <div className="con-bg">검색된 학부모/원생정보가 없습니다.</div>
            </div>
          :varChildrenList.map((childrens,i)=>(
            <div className="con-box" key={'childrens_'+i} onClick={e=>onToggleClassStudyInfoHandler(e,childrens.ch_idx,childrens.cl_idx)}>
              <div className="txt-box">
                <div className="flex">
                  <p>수강정지일</p><div>{ChangeDateStringOnlyDate(childrens.clc_pdate)}</div>
                </div>
                <div className="flex">
                  <p>원생명</p><div>{childrens.ch_name}</div>
                </div>
                <div className="flex">
                  <p>학부모명</p><div>{childrens.mem_name}</div>
                </div>
                <div className="flex">
                  <p>클래스</p><div>{childrens.cl_name}</div>
                </div>
                <div className="flex">
                  <p>미지정수업차수</p><div>{childrens.smc_store}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default ToggleStudySet